'use strict';
const $ = (window.jQuery = window.$ = require('jquery'));

let Selector = {
  checkoutFlow: '#checkout-flow',
  cartDot: '#cart-dot .red-dot',
  shippingDot: '#shipping-dot .red-dot',
  paymentDot: '#payment-dot .red-dot',
  checkoutPage: '#checkout-main',
  shippingButton: '.submit-shipping'
};

let bindEvent = () => {
  let stage = $(Selector.checkoutPage).data().checkoutStage;
  checkStage(stage);
};

let checkStage = (stage) => {
  if (stage === 'shipping') {
    $(Selector.shippingDot).addClass('active');
  } else if (stage === 'payment' || stage === 'placeOrder') {
    $(Selector.shippingDot).addClass('active');
    $(Selector.paymentDot).addClass('active');
  }
};

module.exports = function() {
  //check if we are on the checkout page
  if (document.body.querySelector('#checkout-main') !== null) bindEvent();
};
